import styled from "styled-components";
import { useEffect, useState } from "react";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import ModalWindow from "components/other/ModalWindow";

import fastStartIcon from "assets/img/icons/fast-start-icon.svg";
import countdownIcon from "assets/img/icons/countdown-icon-yellow.svg";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import { numberWithCommas } from "modules/functions";

const FastStartModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: auto;
  transform: translateX(-50%) translateY(-50%);

  width: 100%;
  max-width: 480px;
  padding: 0 10px;
  box-sizing: border-box;
  z-index: ${(props) => (props.zIndex ? props.zIndex : "200")};

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${globalConstants.switchMobile}) {
    width: 100%;
  }
`;

const ModalContent = styled.div`
  padding-top: 30px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Title = styled.div`
  font-size: 34px;
  font-weight: 500;
  text-align: center;
`;

const FastStartIcon = styled.div`
  width: 80px;
  min-width: 80px;
`;

const MainText = styled.div`
  max-width: 330px;

  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 130%;
`;

const CountdownBox = styled.div`
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: ${css.BOX_RADIUS_SECONDARY};

  display: flex;
  align-items: center;
  gap: 14px;
`;

const CountDownIcon = styled.div`
  width: 48px;
  min-width: 48px;
`;

const CountdownText = styled.div`
  font-size: 36px;
  font-weight: 500;
  text-align: center;
`;

const CoinsInfo = styled.div`
  text-align: center;
  line-height: 130%;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

export default ({ closeFastStartModal, amount }) => {
  const [remaining, setRemaining] = useState("00:00:00");

  const UserProperties = createSelector(
    (state) => state.User,
    (user) => ({
      profileData: user.profileData,
    })
  );

  const { profileData } = useSelector(UserProperties);

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date();
      const difference = new Date(profileData.fastStartBonus) - now;

      if (difference <= 0) {
        setRemaining("00:00:00");
        clearInterval(intervalId);
        return;
      }

      const hours = String(Math.floor(difference / (1000 * 60 * 60))).padStart(
        2,
        "0"
      );
      const minutes = String(
        Math.floor((difference / (1000 * 60)) % 60)
      ).padStart(2, "0");
      const seconds = String(Math.floor((difference / 1000) % 60)).padStart(
        2,
        "0"
      );

      setRemaining(`${hours}:${minutes}:${seconds}`);
    };

    const intervalId = setInterval(calculateTimeRemaining, 1000);

    calculateTimeRemaining();

    return () => clearInterval(intervalId);
  }, [profileData]);

  return (
    <FastStartModal>
      <ModalWindow
        handleModalClose={closeFastStartModal}
        fullScreenHeight={true}
      >
        <ModalContent>
          <Title>${profileData.fastStartBonusAmount} Fast Start Bonus</Title>
          <FastStartIcon>
            <img src={fastStartIcon} style={{ width: "100%" }} />
          </FastStartIcon>
          <MainText>
            Find at least {numberWithCommas(profileData.fastStartBonusLimit)}{" "}
            Coins within the first 24 hours of registration and receive a $
            {profileData.fastStartBonusAmount} USD bonus!
          </MainText>
          <CountdownBox>
            <CountDownIcon>
              <img src={countdownIcon} style={{ width: "100%" }} />
            </CountDownIcon>
            <CountdownText>{remaining}</CountdownText>
          </CountdownBox>
          <CoinsInfo>
            Coins are randomly hidden among posts on the Discovery page. The
            coins you find can be exchanged for money or used to display your
            own post.
          </CoinsInfo>
          <ButtonWrap>
            <ButtonPrimary onClick={closeFastStartModal}>
              Get Started
            </ButtonPrimary>
          </ButtonWrap>
        </ModalContent>
      </ModalWindow>
    </FastStartModal>
  );
};
